import type { ReactNode } from "react";
import clsx from "clsx";
import { AlertIcon, CheckIcon, InfoIcon } from "@/components/ui/Icons";

export type NoticeVariant = "info" | "warning" | "success" | "error" | "neutral";

type Props = {
  variant?: NoticeVariant;
  title?: string;
  children?: ReactNode;
  icon?: ReactNode;
  className?: string;
  role?: "status" | "alert";
};

function defaultIcon(variant: NoticeVariant) {
  if (variant === "success") return <CheckIcon />;
  if (variant === "warning" || variant === "error") return <AlertIcon />;
  return <InfoIcon />;
}

export function Notice({
  variant = "info",
  title,
  children,
  icon,
  className,
  role = variant === "error" ? "alert" : "status",
}: Props) {
  return (
    <div
      className={clsx("bk-notice", `bk-notice--${variant}`, className)}
      role={role}
      aria-live={role === "status" ? "polite" : undefined}
    >
      <span className="bk-notice__icon">{icon ?? defaultIcon(variant)}</span>
      <div className="bk-notice__body">
        {title ? <p className="bk-notice__title">{title}</p> : null}
        {children}
      </div>
    </div>
  );
}
